import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isLargeScreen } from '../../../../global.variable';
import { DataCheckService } from '../../services/data-check.service';
import { DeviceInfoService } from '../../services/device-info.service';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { ScreenshotGuideComponent } from '../screenshot-guide/screenshot-guide.component';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'gtapp-getting-started',
  standalone: false,
  templateUrl: './getting-started.component.html',
  styleUrl: './getting-started.component.scss',
})
export class GettingStartedComponent implements OnInit {
  @Input() showFrom: string = 'home';
  @Output() emitEvent = new EventEmitter();

  isDispatchUser = this.dataCheckService.isDispatchUser();
  isAdmin = this.dataCheckService.isUserAdmin();
  isSubscriberAdmin = this.dataCheckService.isSubscriberAdmin();

  isPhoneIOS = this.deviceInfoService.isPhoneIOS();
  iosSafariBrowser: boolean = false;

  // to temp hide the btn in case user missed it and provides a reason on the pages component
  hideMissedWelfareCheckInBtn = false;

  showGettingStartedGuide: boolean = false;
  safariPermissionSettingsUpdated: boolean = false;

  largeView = isLargeScreen;

  gettingStartedParams: any;

  guideOptions: any = [];

  isNativeApp = Capacitor.isNativePlatform();
  constructor(
    private dataCheckService: DataCheckService,
    private deviceInfoService: DeviceInfoService,
    private dialogService: ModalDialogueService,
    private profileService: UserProfileService,
  ) {}

  async ngOnInit(): Promise<void> {
    const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');
    this.gettingStartedParams = userGuide?.gettingStartedGuide || {};

    this.safariPermissionSettingsUpdated =
      localStorage.getItem(btoa('safariPermissionSettingsUpdated')) === 'true';
    if (this.isPhoneIOS && !this.largeView) {
      const currentDeviceInfo: any =
        await this.deviceInfoService.getDeviceInfo();
      const isDevicePWA = this.deviceInfoService.isDevicePWA();
      this.iosSafariBrowser =
        currentDeviceInfo?.browser == 'Safari' && !isDevicePWA;
    }

    const subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );
    this.guideOptions = [
      {
        key: 'addSite',
        header: 'Add a site',
        showItem: this.isAdmin,
        is_completed: false,
        pressed: () => this.showGuideOptions('howToAddSite'),
      },
      // {
      //   key: 'goMobile',
      //   header: 'Go Mobile',
      //   showItem: this.largeView,
      //   is_completed: false,
      //   pressed: () => this.showGuideOptions('signInOnMobile'),
      // },
      {
        key: 'iosPermission',
        header: 'Fix / Allow Permissions',
        showItem: this.iosSafariBrowser && !this.isNativeApp,
        is_completed: this.safariPermissionSettingsUpdated,
        pressed: () => this.openScreenShotComponent(),
      },

      {
        key: 'addUsers',
        header: 'Add Users',
        showItem: this.isAdmin,
        is_completed: false,
        pressed: () => this.showGuideOptions('howToAddUser'),
      },
      // {
      //   key: 'alarms',
      //   header: 'Alarms',
      //   showItem:
      //     (this.isAdmin || this.isDispatchUser) &&
      //     subscriberStats?.company_count > 0,
      //   is_completed: false,
      //   pressed: () => this.showGuideOptions('startAlarmResponse'),
      // },
      // {
      //   key: 'scheduledPatrols',
      //   header: 'Scheduled Patrols',
      //   showItem: this.isAdmin || this.isDispatchUser,
      //   is_completed: false,
      //   pressed: () => {},
      // },
      {
        key: 'installApp',
        header: ' Install App',
        showItem:
          this.iosSafariBrowser &&
          this.safariPermissionSettingsUpdated &&
          !this.isNativeApp,
        is_completed: false,
        pressed: () => this.installPWAApp(),
      },
    ];

    this.guideOptions?.forEach(
      (item: any) =>
        (item.is_completed =
          item?.is_completed ||
          this.gettingStartedParams?.[item?.key] ||
          false),
    );
  }
  showGuideOptions(guideItem: string) {
    this.emitEvent.emit({ guideOptions: guideItem });
  }
  openScreenShotComponent() {
    const dialogRef = this.dialogService.open(ScreenshotGuideComponent, {
      data: { guide: 'safariPermissionPrompts' },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.safariPermissionSettingsUpdated =
        localStorage.getItem(btoa('safariPermissionSettingsUpdated')) ===
        'true';

      const index = this.guideOptions?.findIndex(
        (item: any) => item?.key == 'iosPermission',
      );

      if (index !== -1) {
        this.guideOptions[index] = {
          ...this.guideOptions[index],
          is_completed: this.safariPermissionSettingsUpdated,
        };
      }
    });
  }
  installPWAApp() {
    if (this.isPhoneIOS) {
      this.dialogService.open(ScreenshotGuideComponent, {
        data: {},
      });
    }
  }
  onTaskComplete(guideItem: any) {
    guideItem.is_completed = !guideItem?.is_completed;
    this.updateGuideLevel(guideItem);
  }

  updateGuideLevel(guideItem: any) {
    // method to update the completed steps of the guide in the backend also,
    // so that even if the localStorage is cleared or the user logs in another device it wont be repeated.
    const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');

    userGuide['gettingStartedGuide'] = userGuide?.gettingStartedGuide || {};
    userGuide['gettingStartedGuide'][guideItem?.key] = guideItem?.is_completed;

    this.showGettingStartedGuide = userGuide?.gettingStartedGuide || {};

    this.profileService
      .updateUser(
        {
          data: {
            user_guide_info: userGuide,
          },
        },
        { save_preference: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          localStorage.setItem('userGuide', JSON.stringify(userGuide));
        }
      });
  }
}
